module.exports = __webpack_public_path__ + "img/entrypoint.45fda77c.svg";